import React, { Component } from 'react';
import { Card, Spinner, Button } from 'react-bootstrap';
import { Fetcher } from "../../Helpers/fetcher.js";
import "./index.css";

class ApiDocs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			sheets: [],
			selectedSheetId: null,
			currentPageIndex: 0,
			isLoading: true
		}
	}

	componentDidMount() {
		this.loadSheets();
	}

	componentDidUpdate(prevProps) {
		const prevId = prevProps.match && prevProps.match.params ? prevProps.match.params.sheetId : undefined;
		const currentId = this.props.match && this.props.match.params ? this.props.match.params.sheetId : undefined;
		if (prevId !== currentId) {
			this.selectFromRoute(this.state.sheets, currentId);
		}
	}

	loadSheets = () => {
		Fetcher.get(this.props.app.apiPath + '/api/obd/sheet/content/list/' + this.props.app.userId)
			.then(res => {
				const sheets = Array.isArray(res) ? res : [];
				this.setState({ sheets });
				const routeId = this.props.match && this.props.match.params ? this.props.match.params.sheetId : undefined;
				this.selectFromRoute(sheets, routeId);
			})
			.catch(err => { console.log('Error in fetching Api Docs', err) })
			.finally(() => this.setState({ isLoading: false }));
	}

	selectFromRoute = (sheets, routeId) => {
		const numericId = routeId ? Number(routeId) : null;
		const matched = numericId ? sheets.find(s => s.id === numericId) : null;
		const fallback = sheets.length > 0 ? sheets[0].id : null;
		this.setState({
			selectedSheetId: matched ? matched.id : fallback,
			currentPageIndex: 0
		});
	}

	goPrevious = () => {
		this.setState(prev => ({ currentPageIndex: Math.max(0, prev.currentPageIndex - 1) }));
	}

	goNext = (totalPages) => {
		this.setState(prev => ({ currentPageIndex: Math.min(totalPages - 1, prev.currentPageIndex + 1) }));
	}

	render() {
		const { sheets, selectedSheetId, currentPageIndex, isLoading } = this.state;
		const selectedSheet = sheets.find(s => s.id === selectedSheetId);
		const pages = selectedSheet
			? [selectedSheet.content1, selectedSheet.content2, selectedSheet.content3, selectedSheet.content4, selectedSheet.content5].filter(c => c && c.trim() !== '')
			: [];
		const currentContent = pages[currentPageIndex];

		return (
			<Card>
				<Card.Header>{selectedSheet ? selectedSheet.sheetName : 'API Docs'}</Card.Header>
				<Card.Body>
					{isLoading ? (
						<div className="text-center">
							<Spinner animation="border" />
						</div>
					) : sheets.length === 0 ? (
						<div>No documentation available yet.</div>
					) : !selectedSheet ? (
						<div>Select a document from the sidebar.</div>
					) : pages.length === 0 ? (
						<div>No content available yet.</div>
					) : (
						<>
							<div className="api-docs-pager mb-3">
								<Button
									variant="outline-secondary"
									size="sm"
									onClick={this.goPrevious}
									disabled={currentPageIndex === 0}
								>
									&laquo; Previous
								</Button>
								<span className="mx-3 text-muted">Sheet {currentPageIndex + 1} of {pages.length}</span>
								<Button
									variant="outline-secondary"
									size="sm"
									onClick={() => this.goNext(pages.length)}
									disabled={currentPageIndex === pages.length - 1}
								>
									Next &raquo;
								</Button>
							</div>
							<div
								className="api-docs-sheet-page"
								style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
								dangerouslySetInnerHTML={{ __html: currentContent }}
							/>
						</>
					)}
				</Card.Body>
			</Card>
		);
	}
}

export default ApiDocs;
